export function isSuccessfulStatus({ status }) {
  return status >= 200 && status < 300
}
